import { render, staticRenderFns } from "./lote2.vue?vue&type=template&id=41893d9c&"
import script from "./lote2.vue?vue&type=script&lang=js&"
export * from "./lote2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports